(function ($) {
  Drupal.behaviors.bobbipro = {
    attach: function (context) {
      $('.bobbi-pro__tabs', context).easyResponsiveTabs();
      var $bobbipro = $('.bobbi-pro', context);
      var $questions = $('.bobbi-pro__faq-question', $bobbipro);
      var $bios = $('.bobbi-pro__artist-bio', $bobbipro);
      var $tabLinks = $('.js-tab-link', $bobbipro);
      var bioTemplate = $('.bobbi-pro__artist-bio__content--full', $bobbipro)[0].outerHTML;

      $('.bobbi-pro__artist-bio__content--full', $bobbipro).remove();

      // Generating dynamic id for the answer content in Bobbi PRO FAQ content
      $questions.each(function () {
        var index = $(this).parent().index();

        $(this).parent().find('.js-bobbi-pro-faq-answer-content').attr('id', 'faq-answer-content--' + index);
      });

      $tabLinks.on('click', function (e) {
        e.preventDefault();
        var url = $(this).attr('href');
        var idSelector = url.split('#')[1];

        if (typeof idSelector !== 'undefined') {
          $('#' + idSelector).click();
        } else {
          window.location.href = url;
        }
      });

      // Show the answers when questions on the FAQ are clicked
      $questions.on('click', function (e) {
        e.preventDefault();
        var $container = $(this).parent();
        var id = $container.find('.js-bobbi-pro-faq-answer-content').attr('id');
        var isExpanded = $(this).attr('aria-expanded') === 'true' ? 'false' : 'true';

        $('#' + id).attr('aria-hidden', 'false');
        $(this).attr('aria-expanded', isExpanded);
        if (isExpanded === 'true') {
          $(this).attr('aria-describedby', id);
        } else {
          $(this).removeAttr('aria-describedby');
        }
        $container.toggleClass('active');
        $('.bobbi-pro__faq-answer', $container).stop(true, true).slideToggle();
      });

      // Show the answers when enter key is pressed
      $questions.on('keydown', function (e) {
        if (site.getKeycode(e) === 13) {
          e.preventDefault();
          $(this).trigger('click');
        }
      });

      // FAQ Close
      $('.bobbi-pro__faq-answer__close', $bobbipro).on('click', function (e) {
        e.preventDefault();
        $(this).parent().parent().toggleClass('active').find('.bobbi-pro__faq-question').attr('aria-expanded', 'false').focus();
        $(this).parent().stop(true, true).slideToggle();
      });

      // Close FAQ answer on pressing close button
      $('.bobbi-pro__faq-answer__close', $bobbipro).on('keydown', function (e) {
        e.preventDefault();
        if (site.getKeycode(e) === 13) {
          $(this).trigger('click');
        }
      });

      // Build your pro kit attributes
      var $context = $('.js-bobbi-pro__section--products');
      var $menuLink = $('.js-bobbi-pro__section-content a', $context);
      var $menuHeaderName = $('.js-bobbi-pro__section-header', $context).attr('id');

      $menuLink.on('focusin', function () {
        $(this).attr('aria-describedby', $menuHeaderName);
      });

      // When a bio link is clicked, show the full bio.
      $bios.on('click', '.bobbi-pro__artist-bio__link', function (e) {
        e.preventDefault();
        var $bio = $(this).parent();

        if ($bio.hasClass('active')) {
          $(this).attr('aria-expanded', 'false');
          $bio.removeClass('active');
          $bobbipro.find('.bobbi-pro__artist-bio__content--full').slideUp(200);
          setTimeout(function () {
            $bobbipro.find('.bobbi-pro__artist-bio__content--full').remove();
          }, 300);
          $bio.focus();

          return;
        }
        $bios.removeClass('active');
        $bio.addClass('active');
        $(this).attr('aria-expanded', 'true').focus();
        var $arrow;
        var bioContent = $('.bobbi-pro__artist-bio__content', $bio).html();
        var topOffset = $bio.offset().top;
        var leftOffset = 0;
        var indexOfBio = 0;
        var openedBio = false;

        // Loop through the bios. The next one with a higher offset than this one (new row) is where we want to insert the new bio
        $bios.each(function (i) {
          if (openedBio) {
            return;
          }
          // Our first bio's left position is the offset, because we want to subtract this value.
          if (i === 0) {
            leftOffset = $(this).position().left;
          }
          var $htmlToInsert = $(bioTemplate).removeClass('hidden');

          $('.bobbi-pro__artist-bio__content-wrapper', $htmlToInsert).html(bioContent);
          var leftPosition = $bio.position().left + ($bio.width() / 2) - leftOffset;

          // If this element has a higher offset than our current element, we've reached a new row
          if ($(this).offset().top > topOffset) {
          // If we've already appended a full bio to the row, then just swap out that HTML.
          // Othewise, we remove and close out any existing ones in other rows and show our current one.
            if ($(this).prev().hasClass('bobbi-pro__artist-bio__content--full')) {
              $(this).prev().find('.bobbi-pro__artist-bio__content-wrapper').html(bioContent);
            } else {
              $('.bobbi-pro__artist-bio__content--full', $bobbipro).remove();
              $htmlToInsert.insertBefore($(this));
              $('.bobbi-pro__artist-bio__content-wrapper', $bobbipro).slideDown(300);
              $arrow = $('.bobbi-pro__artist-bio__content-arrow', $bobbipro);
              $arrow.css({ left: leftPosition }); // To make sure it doesnt animate if there isnt an existing bio open
            }
            openedBio = true;
            $arrow = $('.bobbi-pro__artist-bio__content-arrow', $bobbipro);
            $arrow.animate({ left: leftPosition }, 300);

            // We've reached the end
          } else if (i === $bios.length - 1) {
          // If we've already appended a full bio to the row, then just swap out that HTML.
          // Othewise, we remove and close out any existing ones in other rows and show our current one.
            if ($(this).next().hasClass('bobbi-pro__artist-bio__content--full')) {
              $(this).next().find('.bobbi-pro__artist-bio__content-wrapper').html(bioContent);
            } else {
              $('.bobbi-pro__artist-bio__content--full', $bobbipro).remove();
              $htmlToInsert.insertAfter($(this));
              $('.bobbi-pro__artist-bio__content-wrapper', $bobbipro).slideDown(300);
            }
            openedBio = true;
            $arrow = $('.bobbi-pro__artist-bio__content-arrow', $bobbipro);
            var leftPosition = $bio.position().left + ($bio.width() / 2) - leftOffset;

            $arrow.animate({ left: leftPosition }, 300);
          }
        });
      });
    }
  };
})(jQuery);
